import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";

export default function AdminNav() {
    const { logout, user } = useAuth();
    const loc = useLocation();
    const nav = useNavigate();
    const link = (to, label, testid) => (
        <Link to={to} data-testid={testid} className={`px-3 py-1.5 text-sm border ${loc.pathname === to ? "border-green-700 text-green-800 bg-green-50" : "border-gray-200 text-gray-700 hover:bg-gray-50"}`}>
            {label}
        </Link>
    );
    return (
        <div className="border-b border-gray-200 bg-white sticky top-0 z-10">
            <div className="max-w-6xl mx-auto px-4 py-3 flex items-center justify-between gap-3 flex-wrap">
                <div className="flex items-center gap-2">
                    <div className="font-bold text-gray-900 text-base">MAX AGENDA</div>
                    <div className="text-xs text-gray-500 hidden sm:block">Area riservata</div>
                </div>
                <div className="flex items-center gap-2 flex-wrap">
                    {link("/admin", "Agenda", "nav-agenda")}
                    {link("/admin/settings", "Impostazioni", "nav-settings")}
                    {link("/admin/emails", "Email", "nav-emails")}
                    <span className="text-xs text-gray-500 hidden sm:inline">{user?.email}</span>
                    <Button variant="outline" size="sm" onClick={() => { logout(); nav("/admin/login"); }} data-testid="logout-btn">Esci</Button>
                </div>
            </div>
        </div>
    );
}
